import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

import {
  VolumesFaqsComponent
} from '@ruby/modules/revenue/submodules/contract-volumes-help/components/volumes-faqs/volumes-faqs.component';
import {
  VolumesHelpComponent
} from '@ruby/modules/revenue/submodules/contract-volumes-help/components/volumes-help/volumes-help.component';
import {
  VolumesStatusesComponent
} from '@ruby/modules/revenue/submodules/contract-volumes-help/components/volumes-statuses/volumes-statuses.component';
import {
  ContractVolumesHelpRoutingModule
} from '@ruby/modules/revenue/submodules/contract-volumes-help/contract-volumes-help-routing.module';

@NgModule({
  declarations: [
    VolumesHelpComponent,
    VolumesStatusesComponent,
    VolumesFaqsComponent
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    ContractVolumesHelpRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    MatExpansionModule
  ]
})
export class ContractVolumesHelpModule {}
